import React, { Component } from 'react'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { Button } from 'components/misc'
import { modal } from 'redux/modules/app'
import { form } from 'helpers/decorators'

const enhance = compose(
  connect(null, { modal }),
  form({
    form: 'remove-label-form'
  })
)

class LabelRemove extends Component {
  static propTypes = {
    onDeleteLabel: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    modal: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    id: PropTypes.number
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
      return
    }

    this.props.modal(null)
  }

  render() {
    const {
      id,
      handleSubmit,
      submitting
    } = this.props

    return (
      <form
        onSubmit={handleSubmit(() => this.props.onDeleteLabel(id)
        )}
      >
        <div className="row">
          <div className="col-xs-12">
            <h2 className="text--center">
              <FormattedMessage
                  id="participant.would_you_like_to_remove_label"
                  defaultMessage="Would you like to delete this label?"
              />
            </h2>
          </div>

          <div className="col-xs-6">
            <Button type="button" onClick={this.handleClose} secondary>
              <FormattedMessage id="button.close" defaultMessage="Close" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button
              negative
              isLoading={submitting}
            >
              <FormattedMessage id="button.remove" defaultMessage="Remove" />
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default enhance(LabelRemove)
